import React, {SVGProps} from 'react';

import { ReactComponent } from '../../assets/svg/arrow_forward.svg';


export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
